import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'deploymentStatus'
})
export class DeploymentStatusPipe implements PipeTransform{
    transform(value: any) {
        if(value === "InProgress"){
            return "In Progress";
        }
        return value;
    }
}